<template>
<div>           
    <div class="mt-5 py-5 border-top">
      <div class="row justify-content-center">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 mb-2"><h5 class="text-center">แก้ไขข้อมูลส่วนตัว</h5></div>
                    <div class="col-lg-12">
                        <form>
                            <div class="row">
                                
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>ID ผู้ใช้</label>
                                        <input type="text" class="form-control" v-model="user.users_id" disabled>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>อีเมล</label>
                                        <input type="email" v-model="user.users_email" name="users_email" id="users_email" class="form-control" placeholder="อีเมล">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>ชื่อ</label>
                                        <input type="text" v-model="user.users_name" name="users_name" id="users_name" class="form-control" placeholder="ชื่อ">
                                    </div>
                                </div>


                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>นามสกุล</label>
                                        <input type="text" v-model="user.users_lastname" name="users_lastname" id="users_lastname" class="form-control" placeholder="นามสกุล">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="tel">เบอร์โทร</label>
                                        <input type="number" 
                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "10"
                                        class="form-control"  v-model="user.users_tel" id="users_tel" name="users_tel" placeholder="เบอร์โทร">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>ไปรษณีย์</label>
                                        <input type="number" 
                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "6"
                                        class="form-control" v-model="user.users_zipcode" placeholder="ไปรษณีย์" name="users_zipcode" id="users_zipcode">
                                    </div>
                                </div>
                                
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>ที่อยู่</label>
                                        <textarea  v-model="user.users_address" id="users_address" name="users_address" rows="5" class="form-control" :placeholder="user.users_address"></textarea>
                                    </div>
                                </div>
                                

                                <div class="col-md-12 text-center">
                                    <div class="btn btn-warning" @click="updateUser()"><i class="fa fa-edit"></i> บันทึก</div>
                                </div>
                            
                            </div>
                        </form>
                    </div>
                </div>

        
                </div>

        </div>
      </div>

</div>
</template>

<script>
import UserStore from "@/stores/UserStore";
import router from "@/router";
export default {
  name: 'SettingProfile',
  components: {
    // HeaderShop
  },
  data(){
      return {
        user: [],
      }
  },
  methods: {
    hasNumber(myString){
        return /\d/.test(myString);
    },
    getUser: async function() {
      if (!localStorage.access_token) router.push("/");
      let optionts = {
        access_token: localStorage.access_token
      };
      await UserStore.dispatch("getUser", optionts);
      if (UserStore.state.user.status == 200) {
        this.user = UserStore.state.user.user;
      } else if (UserStore.state.user.status == 400) {
        router.push("/logout");
      }
    },
    updateUser: async function() { 
        if(this.hasNumber(this.user.users_name+this.user.users_lastname)){
            return alert('โปรดกรอกข้อมูลให้ถูกต้อง')
        }
      if (!localStorage.access_token) router.push("/");
      if (

            this.user.users_email == '' || 
            this.user.users_name == '' || 
            this.user.users_lastname == '' ||
            this.user.users_tel == '' ||
            this.user.users_zipcode == '' ||
            this.user.users_address == '' ||

            this.user.users_email == undefined || 
            this.user.users_name == undefined || 
            this.user.users_lastname == undefined ||
            this.user.users_tel == undefined ||
            this.user.users_zipcode == undefined ||
            this.user.users_address == undefined
  
            ) {
            return alert('โปรดกรอกข้อมูลให้ครบถ้วน')
        }
      let optionts = {
        access_token: localStorage.access_token,
        users_email: this.user.users_email,
        users_name: this.user.users_name,
        users_lastname: this.user.users_lastname,
        users_tel: this.user.users_tel,
        users_zipcode: this.user.users_zipcode,
        users_address: this.user.users_address
      };
      await UserStore.dispatch("updateUser", optionts);
      if (UserStore.state.updateUser.status == 200) {
        alert("อัพเดทข้อมูลสำเร็จ")
        await this.getUser();
      } else if (UserStore.state.updateUser.status == 400) {
        alert(UserStore.state.updateUser.msg)
      }
    },

  },
  async mounted() {
    await this.getUser();
  }
  
}
</script>